// OF·27 — theme.js
(function () {
  // Cart drawer
  const drawer   = document.querySelector('[data-cart-drawer]');
  const openBtns = document.querySelectorAll('[data-cart-open]');
  const closeBtns= document.querySelectorAll('[data-cart-close]');
  const overlay  = document.querySelector('[data-cart-overlay]');

  function openCart() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
  }

  openBtns.forEach(b => b.addEventListener('click', e => { e.preventDefault(); openCart(); }));
  closeBtns.forEach(b => b.addEventListener('click', closeCart));
  if (overlay) overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  // AJAX add-to-cart for drawer forms only. Buy forms that carry their own
  // redirect (name="return_to") or sit inside a product-detail section post
  // natively so Shopify renders the accelerated checkout button and sends the
  // buyer to /checkout itself.
  function ownsItsOwnSubmit(form) {
    if (form.classList.contains('pdp__form') || form.classList.contains('srp__form')) return true;
    if (form.querySelector('input[name="return_to"]')) return true;
    if (form.closest('[data-section*="product-detail"]')) return true;
    if (form.closest('.pdp, .srp, .sysp, .pd, .stry, .sysclose, [data-pdp-panes], [data-srp-panes]')) return true;
    return false;
  }
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    if (ownsItsOwnSubmit(form)) return;
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const fd = new FormData(form);
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        if (!res.ok) { form.submit(); return; }
      } catch (err) { form.submit(); return; }
      openCart();
    });
  });

  // Drawer line quantity / remove (delegated: survives re-renders)
  let cartBusy = false;
  async function changeQty(key, quantity) {
    if (cartBusy) return;
    cartBusy = true;
    const body = document.querySelector('[data-cart-contents]');
    if (body) body.setAttribute('aria-busy', 'true');
    try {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: quantity }) });
    } catch (err) { /* refresh below shows the true state */ }
    cartBusy = false;
    await refreshCart();
    if (body) body.removeAttribute('aria-busy');
  }
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-cd-qty], [data-cd-remove]');
    if (!btn) return;
    const key = btn.getAttribute('data-key');
    if (!key) return;
    let qty = 0;
    if (btn.hasAttribute('data-cd-qty')) {
      qty = Math.max(0, parseInt(btn.getAttribute('data-qty') || '1', 10) + parseInt(btn.getAttribute('data-cd-qty'), 10));
    }
    changeQty(key, qty);
  });

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
  function isAdvanced(item) { return /advanced/i.test(item.variant_title || ''); }
  function renderLine(item) {
    const pre = item.properties && (item.properties['Pre-order'] || item.properties['Founding Batch'] === 'Yes');
    const vt = item.variant_title && item.variant_title !== 'Default Title' ? ' \u00b7 ' + esc(item.variant_title) : '';
    const img = item.image
      ? '<img src="' + item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=128" alt="" loading="lazy">'
      : '<span class="cd-line__mark">OF\u00b727</span>';
    return '<div class="cd-line">' +
      '<a class="cd-line__thumb" href="' + item.url + '">' + img + '</a>' +
      '<div class="cd-line__info">' +
        '<a class="cd-line__name" href="' + item.url + '">' + esc(item.product_title) + vt + '</a>' +
        (item.sku ? '<div class="cap cd-line__meta">\u2014 ' + esc(item.sku) + '</div>' : '') +
        (pre ? '<div class="cap cd-line__meta">\u2014 Pre-order \u00b7 ships mid-October</div>' : '') +
        '<div class="cd-line__row">' +
          '<div class="cd-qty" role="group" aria-label="Quantity">' +
            '<button type="button" class="cd-qty__btn" data-cd-qty="-1" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Decrease quantity">\u2212</button>' +
            '<span class="cd-qty__value">' + item.quantity + '</span>' +
            '<button type="button" class="cd-qty__btn" data-cd-qty="1" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button type="button" class="cd-line__remove" data-cd-remove data-key="' + item.key + '">Remove</button>' +
        '</div>' +
      '</div>' +
      '<div class="cd-line__price">' + formatMoney(item.final_line_price) + '</div>' +
    '</div>';
  }

  // Refresh cart HTML from /cart.js
  async function refreshCart() {
    const target = document.querySelector('[data-cart-contents]');
    if (!target) return;
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      const count = document.querySelector('[data-cart-count]');
      if (count) count.textContent = cart.item_count;
      const head = document.querySelector('[data-cd-count]');
      if (head) head.textContent = cart.item_count > 0 ? ' \u00b7 ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') : '';
      const subtotal = document.querySelector('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
      const foot = document.querySelector('[data-cart-foot]');
      if (foot) foot.hidden = cart.item_count === 0;
      const guarantee = document.querySelector('[data-cd-guarantee]');
      if (guarantee) guarantee.hidden = cart.items.some(isAdvanced);

      if (cart.item_count === 0) {
        const tpl = document.getElementById('cd-empty-template');
        target.innerHTML = tpl ? tpl.innerHTML : '<div class="cd-empty"><p class="cd-empty__line">Nothing reserved yet.</p></div>';
        return;
      }
      target.innerHTML = cart.items.map(renderLine).join('');
    } catch (e) { /* silent */ }
  }
  function formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
  }

  // Initial cart count fetch
  refreshCart();

  // Mobile nav
  const mobileToggle = document.querySelector('[data-mobile-toggle]');
  const mobileNav    = document.querySelector('[data-mobile-nav]');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', () => {
      const open = mobileNav.getAttribute('data-open') === 'true';
      mobileNav.setAttribute('data-open', open ? 'false' : 'true');
    });
    mobileNav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
      mobileNav.setAttribute('data-open', 'false');
    }));
  }
})();

// Mobile: swipe the PDP gallery (drives the existing prev/next controls)
(function () {
  const media = document.querySelector('.pdp__media, .sysp__media');
  if (!media) return;
  let x0 = null, y0 = null;
  media.addEventListener('touchstart', function (e) {
    x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
  }, { passive: true });
  media.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    const dx = e.changedTouches[0].clientX - x0;
    const dy = e.changedTouches[0].clientY - y0;
    x0 = null;
    if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.5) {
      const btn = document.querySelector(dx < 0 ? '[data-img-nav="1"]' : '[data-img-nav="-1"]');
      if (btn) btn.click();
    }
  }, { passive: true });
})();
